import { Injectable, inject } from '@angular/core';
import { Observable } from 'rxjs';
import { HttpRestService } from '@core/services/http-rest';
import { ActiveBankAccount } from '../../models/bank-account.model';

@Injectable({ providedIn: 'root' })
export class ActiveBankAccountsService {
  private readonly _http = inject(HttpRestService);

  getActiveBankAccounts(): Observable<ActiveBankAccount[]> {
    return this._http.get<ActiveBankAccount[]>('bank-accounts/active');
  }
}
